const MassiaNavigationConfigConstant = {
	help: {
		id: 'help',
		translate: 'LAYOUT.HELP.TITLE',
		items: [
			{
				id: 'help_version',
				type: 'navigation_dropdown',
				translate: '<%{ Version }%>',
				items: []
			},
			{
				id: 'help_recap_maj',
				translate: 'LAYOUT.HELP.RECAP_MAJ',
				modale: 'recap-maj'
			},
			{
				id: 'help_espace_client_fr',
				translate: 'LAYOUT.HELP.ESPACE_CLIENT',
				href: 'https://www.arcade.fr/Espace_client/connexion.aspx?lng=FR',
				lng: 'fr'
			},
			{
				id: 'help_espace_client_es',
				translate: 'LAYOUT.HELP.ESPACE_CLIENT',
				href: 'https://www.arcade.fr/Espace_client/connexion.aspx?lng=ES',
				lng: 'es'
			},
			{
				id: 'help_espace_client_en',
				translate: 'LAYOUT.HELP.ESPACE_CLIENT',
				href: 'https://www.arcade.fr/Espace_client/connexion.aspx?lng=EN',
				lng: 'en'
			},
			{
				id: 'help_espace_client_nl',
				translate: 'LAYOUT.HELP.ESPACE_CLIENT',
				href: 'https://www.arcade.fr/Espace_client/connexion.aspx?lng=EN',
				lng: 'nl'
			},
			{
				id: 'help_arcade',
				translate: 'LAYOUT.HELP.ARCADE',
				href: 'https://www.arcade.fr'
			},
			{
				id: 'help_hotline_mail',
				translate: 'LAYOUT.HELP.HOTLINE_MAIL',
				href: 'mailto:hotline@arcade.fr'
			},
			{
				id: 'help_telemaintenance_fr',
				translate: 'LAYOUT.HELP.TELEMAINTENANCE',
				href: 'https://get.teamviewer.com/arcadefr',
				lng: 'fr'
			},
			{
				id: 'help_telemaintenance_es',
				translate: 'LAYOUT.HELP.TELEMAINTENANCE',
				href: 'https://get.teamviewer.com/arcadees',
				lng: 'es'
			},
			{
				id: 'help_telemaintenance_en',
				translate: 'LAYOUT.HELP.TELEMAINTENANCE',
				href: 'https://get.teamviewer.com/arcadeen',
				lng: 'en'
			},
			{
				id: 'help_telemaintenance_nl',
				translate: 'LAYOUT.HELP.TELEMAINTENANCE',
				href: 'https://get.teamviewer.com/arcadeen',
				lng: 'nl'
			},
			{
				id: 'help_phone',
				type: 'navigation_dropdown',
				translate: 'LAYOUT.HELP.PHONE',
				items: []
			}
		]
	},
	tools: {
		id: 'outils',
		icon: 'massia-icon-menu',
		position: 'right',
		translate: 'LAYOUT.NAVIGATION.OUTILS',
		translateCls: 'visible-xs-inline',
		order: 1,
		items: [
			{
				header: true,
				translate: 'LAYOUT.NAVIGATION.OUTILS'
			},
			{
				id: 'outils_historique',
				translate: 'LAYOUT.NAVIGATION.HISTORIQUE',
				rights: { domain: 'histo', right: 'read' },
				sref: 'historique.list'
			},
			{
				id: 'outils_monitoring',
				translate: 'LAYOUT.NAVIGATION.MONITORING',
				rights: { domain: 'monitoring', right: 'read' },
				sref: 'monitoring.list'
			},
			{
				id: 'outils_bet-constituant',
				translate: 'LAYOUT.NAVIGATION.BETCONSTITUANT',
				rights: { domain: 'controlepesee', right: 'read' },
				sref: 'bet-constituant.list'
			},
			{
				id: 'outils_seuil-bet-gach',
				translate: 'LAYOUT.NAVIGATION.SEUILBETGACH',
				rights: { domain: 'controlepesee', right: 'read' },
				sref: 'seuil-bet-gach.list'
			},
			{
				id: 'outils_monitoring_synchro',
				translate: 'LAYOUT.NAVIGATION.MONITORING_SYNCHRO',
				rights: { domain: 'monitoringsync', right: 'read' },
				sref: 'monitoringsynchro.list'
			},
			{
				id: 'outils_activation_synchro_site_web',
				translate: 'LAYOUT.NAVIGATION.ACTIVATION_SYNCHRO_SITE_WEB',
				rights: { domain: 'synchrosite', right: 'read', application: 'gestion' },
				sref: 'activation-site-synchro.edit'
				//clientRestriction: ['EIFFAGE'],
			},
			{
				id: 'outils_affectation_poste_pesee',
				translate: 'LAYOUT.NAVIGATION.AFFECTATION_POSTE_PESEE',
				rights: { domain: 'postepesee', right: 'read', application: 'gestion' },
				sref: 'affectation-poste-pesee.edit'
				//clientRestriction: ['EIFFAGE']
			},
			{
				id: 'outils_parametrage_general',
				translate: 'LAYOUT.NAVIGATION.PARAMETRAGE_GENERAL',
				rights: { domain: 'paramprog', right: 'read' },
				sref: 'parametrage-general.edit'
			},
			{
				id: 'outils_import_donnees',
				translate: 'LAYOUT.NAVIGATION.IMPORT_DONNEES',
				rights: { domain: 'importdonnees', right: 'read', application: 'performance;gestion' },
				sref: 'importdonnees.edit'

				//clientRestriction: ['EIFFAGE'],
			},
			{
				id: 'outils_prefa_auto',
				translate: 'PLANIFICATION_JOB_PREFACTURATIONS.BREADCRUMBS.PLANIFICATION_JOB_PREFACTURATIONS_LIST',
				rights: { domain: 'prefavente', right: 'read', application: 'gestion' },
				sref: 'planification-job-prefacturations.list'
				//clientRestriction: ['EIFFAGE'],
			},
			/*{
				id: 'outils_transfert_donnees',
				translate: 'LAYOUT.NAVIGATION.TRANSFERT_DONNEES',
				sref: '#' // TODO brancher
			},
			{
				id: 'outils_taches_externes',
				translate: 'LAYOUT.NAVIGATION.TACHES_EXTERNES',
				sref: '#' // TODO brancher
			},*/
			{
				id: 'administration_portail',
				translate: 'PORTAIL.BREADCRUMBS.PORTAIL',
				rights: { domain: 'portail', right: 'read', application: 'gestion' },
				sref: 'portail.home'
			},
			{
				id: 'outils_configuration-email',
				translate: 'LAYOUT.NAVIGATION.CONFIGURATION_EMAIL',
				rights: { domain: 'configemail', right: 'read' },
				sref: 'configuration-email.list'
			},
			{
				header: true,
				translate: 'LAYOUT.NAVIGATION.APPLICATIONS'
			},
			{
				id: 'applications_gestion',
				translate: 'LAYOUT.NAVIGATION.GESTION',
				href: 'gestion.html',
				href_EIFFAGE: 'http://advgranulatsindustries.eiffage.com/MassiaClient/gestion.html#/login'
			},
			{
				id: 'applications_performance',
				translate: 'LAYOUT.NAVIGATION.PERFORMANCE',
				href: 'performance.html',
				href_EIFFAGE: 'https://eiffage-performance.arcade.fr/'
			},
			{
				id: 'applications_qse',
				translate: 'LAYOUT.NAVIGATION.QSE',
				href: 'qse.html'
			},
			{
				id: 'applications_laboratoire',
				translate: 'LAYOUT.NAVIGATION.LABORATOIRE',
				href: 'laboratoire.html'
			}
		]
	},
	navigationMenus: [
		// 1
		{
			id: 'donnees',
			type: 'navigation_dropdown',
			icon: 'massia-icon-gearwheel',
			position: 'center',
			translate: 'LAYOUT.NAVIGATION.DONNEES_PARAMETRES',
			order: 1,
			items: []
		},
		//DONNEES & PARAMETRES 2
		{
			id: 'parametres',
			type: 'navigation_dropdown',
			icon: 'massia-icon-gearwheel',
			position: 'center',
			translate: 'LAYOUT.NAVIGATION.DONNEES_PARAMETRES',
			order: 2,
			items: [
				//DONNEES
				{
					id: 'donnees_parametres_donnees',
					order: 1,
					header: true,
					collapse: false,
					translate: 'LAYOUT.NAVIGATION.DONNEES_PARAMETRES_DONNEES',
					items: [
						{
							id: 'sites.list.commerciaux',
							sref: "sites.list({genre: 'commerciaux'})",
							translate: 'SITES.BREADCRUMBS.SITES_COMMERCIAUX_LIST',
							rights: { domain: 'siteutil', right: 'read', application: 'gestion' },
							order: 2
						},
						{
							id: 'sites.list.clients',
							sref: "clients.list({genre: 'clients'})",
							translate: 'SITES.BREADCRUMBS.SITES_CLIENTS_LIST',
							rights: { domain: 'siteclient', right: 'read', application: 'gestion;laboratoire' },
							order: 13
						},
						{
							id: 'chantiers.list.chantiers',
							sref: 'chantiers.list',
							translate: 'CHANTIERS.BREADCRUMBS.CHANTIERS_LIST',
							rights: { domain: 'chantiers', right: 'read', application: 'gestion;performance;laboratoire' },
							order: 14
						},
						{
							id: 'types.client.list',
							sref: 'types.clientlist',
							translate: 'TYPES.BREADCRUMBS.TYPES_CLIENT_LIST',
							rights: { domain: 'types', right: 'read', application: 'gestion' },
							order: 15
						},
						{
							id: 'types.produit.list',
							sref: 'types.produitlist',
							translate: 'TYPES.BREADCRUMBS.TYPES_PRODUIT_LIST',
							rights: { domain: 'types', right: 'read', application: 'gestion' },
							order: 10
						},
						{
							id: 'sites.list.fournisseurs',
							sref: "fournisseurs.list({genre: 'fournisseurs'})",
							translate: 'SITES.BREADCRUMBS.SITES_FOURNISSEURS_LIST',
							rights: { domain: 'sitefourn', right: 'read', application: 'gestion;performance;laboratoire' },
							order: 37
						},
						{
							id: 'chantiers.list.provenances',
							sref: 'provenances.list',
							translate: 'CHANTIERS.BREADCRUMBS.PROVENANCE_LIST',
							rights: { domain: 'chantiers', right: 'read', application: 'gestion;performance;laboratoire' },
							navigationCls: 'menu-item-separator',
							order: 37
						},
						{
							id: 'sites.list.producteurs',
							sref: "producteurs.list({genre: 'producteurs'})",
							translate: 'SITES.BREADCRUMBS.SITES_PRODUCTEURS_LIST',
							order: 8,
							rights: { domain: 'siteprod', right: 'read' }
						},
						{
							id: 'personnes.list.personne',
							sref: "personnes.list({genre: 'personne'})",
							translate: 'PERSONNES.BREADCRUMBS.PERSONNES_LIST',
							order: 6,
							navigationCls: 'menu-item-separator',
							rights: { domain: 'personnel', right: 'read', application: 'qse;laboratoire;gestion' }
						},
						{
							id: 'personnes.list.contact',
							sref: "contacts.list({genre: 'contact'})",
							translate: 'PERSONNES.BREADCRUMBS.CONTACTS_LIST',
							order: 16,
							navigationCls: 'menu-item-separator',
							rights: { domain: 'contacts', right: 'read', application: 'qse;laboratoire;gestion' }
						}
					]
				},
				//DOCUMENTS ET IMAGES
				{
					id: 'donnees_parametres_docimg',
					order: 2,
					header: true,
					collapse: false,
					translate: 'LAYOUT.NAVIGATION.DONNEES_PARAMETRES_DOC_IMG',
					items: []
				},
				//PARAMETRES
				{
					id: 'donnees_parametres_parametres',
					order: 3,
					header: true,
					collapse: false,
					translate: 'LAYOUT.NAVIGATION.DONNEES_PARAMETRES_PARAMETRES',
					items: []
				},
				//CONNEXION
				{
					id: 'donnees_parametres_connexion',
					order: 4,
					header: true,
					collapse: false,
					translate: 'LAYOUT.NAVIGATION.DONNEES_PARAMETRES_CONNEXION',
					items: [
						{
							id: 'personnes.list.utilisateur',
							sref: "utilisateurs.list({genre: 'utilisateur'})",
							translate: 'UTILISATEURS.BREADCRUMBS.UTILISATEURS_LIST',
							order: 4,
							//navigationCls: "menu-item-separator",
							rights: { domain: 'utilisateurs', right: 'read' }
						}
					]
				},
				{
					id: 'donnees_parametres_no_category',
					order: 5,
					header: true,
					collapse: false,
					items: []
				}
			]
		},
		//(G) TRANSPORT 3
		{
			id: 'transport',
			type: 'navigation_dropdown',
			icon: 'massia-icon-delivery_truck',
			position: 'center',
			translate: 'LAYOUT.NAVIGATION.TRANSPORT',
			order: 3,
			items: [
				{
					id: 'transport_no_category',
					header: true,
					collapse: false,
					order: 1,
					items: [
						{
							id: 'societes.list.transporteurs',
							sref: "societes-transporteur.list({genre: '16'})",
							translate: 'SOCIETES.BREADCRUMBS.SOCIETES_TRANSPORTEUR_LIST',
							rights: { domain: 'societes', right: 'read' },
							order: 2
						},
						{
							id: 'sites.list.transporteurs',
							sref: "transporteurs.list({genre: 'transporteurs'})",
							translate: 'SITES.BREADCRUMBS.SITES_TRANSPORTEURS_LIST',
							rights: { domain: 'sitetransp', right: 'read' },
							order: 3
						},
						{
							id: 'personnes.list.chauffeur',
							sref: "chauffeurs.list({genre: 'chauffeur'})",
							translate: 'PERSONNES.BREADCRUMBS.CHAUFFEURS_LIST',
							order: 1,
							rights: { domain: 'chauffeurs', right: 'read' }
						}
					]
				},
				{
					id: 'tarification_transport',
					header: true,
					collapse: false,
					order: 2,
					translate: 'LAYOUT.NAVIGATION.TARIFICATION_TRANSPORT',
					items: []
				},
				{
					id: 'vehicule',
					header: true,
					collapse: false,
					order: 3,
					translate: 'LAYOUT.NAVIGATION.VEHICULE',
					items: []
				},
				{
					id: 'transport_plannings',
					header: true,
					collapse: false,
					order: 4,
					translate: 'LAYOUT.NAVIGATION.TRANSPORT_PLANNINGS',
					items: []
				}
			]
		},
		//(G) GESTION COMMERCIALE 4
		{
			id: 'gestion_commerciale',
			type: 'navigation_dropdown',
			icon: 'glyphicon glyphicon-stats',
			position: 'center',
			translate: 'LAYOUT.NAVIGATION.GESTION_COMMERCIALE',
			order: 4,
			items: [
				{
					id: 'gestion_commerciale_commercial',
					header: true,
					collapse: false,
					order: 3,
					//translate: 'LAYOUT.NAVIGATION.GESTION_COMMERCIALE_COMMERCIAL',
					items: []
				}
			]
		},
		//(G) PESEES ET FACTURATION 5
		{
			id: 'pesees_livraisons',
			type: 'navigation_dropdown',
			icon: 'glyphicon glyphicon-scale',
			position: 'center',
			header: true,
			collapse: false,
			translate: 'LAYOUT.NAVIGATION.PESEES_FACTURATIONS',
			order: 5,
			items: [
				{
					id: 'pesees_livraisons',
					header: true,
					collapse: false,
					order: 1,
					translate: 'LAYOUT.NAVIGATION.PESEES_LIVRAISONS',
					items: []
				},
				{
					id: 'facturation',
					header: true,
					collapse: false,
					order: 2,
					translate: 'LAYOUT.NAVIGATION.FACTURATION',
					items: []
				},
				{
					id: 'inertes',
					header: true,
					collapse: false,
					order: 3,
					translate: 'LAYOUT.NAVIGATION.INERTE',
					items: []
				},
				{
					id: 'registres-legacy',
					header: true,
					collapse: false,
					order: 4,
					translate: 'LAYOUT.NAVIGATION.REGISTRES_LEGACY',
					items: []
				},
				{
					id: 'registres',
					header: true,
					collapse: false,
					order: 5,
					translate: 'LAYOUT.NAVIGATION.REGISTRES',
					items: []
				}
			]
		},
		//(G) STOCKS 6
		{
			id: 'stocks',
			type: 'navigation_dropdown',
			icon: 'glyphicon glyphicon-briefcase',
			position: 'center',
			translate: 'LAYOUT.NAVIGATION.STOCKS',
			order: 6,
			items: [
				{
					id: 'stocks_no_category',
					header: true,
					collapse: false,
					order: 1,
					//translate: 'LAYOUT.NAVIGATION.GESTION_COMMERCIALE_COMMERCIAL',
					items: []
				},
				{
					id: 'stocks_cloture',
					header: true,
					collapse: false,
					order: 2,
					translate: 'LAYOUT.NAVIGATION.STOCK_CLOTURE',
					items: []
				},
				{
					id: 'stocks_configuration',
					header: true,
					collapse: false,
					order: 3,
					translate: 'LAYOUT.NAVIGATION.CONFIGURATION',
					items: [],
					rights: { domain: 'stockconfig', right: 'read' }
				}
			]
		},
		// Synthèse 2.0
		{
			id: 'massia_syntheses',
			type: 'navigation',
			/* rights: { domain: 'synthadmin', right: 'read' }, */
			icon: 'massia-icon-chart_column',
			translate: 'LAYOUT.NAVIGATION.SYNTHESE',
			order: 20,
			position: 'center',
			items: [
				{
					id: 'massia_synth_synth',
					order: 3,
					header: true,
					collapse: false,
					items: [
						{
							id: 'massia_syntheses_old',
							type: 'navigation',
							rights: { domain: 'massiasynthapp', right: 'read' },
							translate: 'LAYOUT.NAVIGATION.SYNTHESE_OLD',
							sref: 'massiasyntheses',
							order: 0
						}
					]
				}
			]
		}
	]
};

export default MassiaNavigationConfigConstant;
